// extracted by mini-css-extract-plugin
module.exports = {"card":"ConditionCard_card__ZcyH_","link":"ConditionCard_link__Bwjj_"};